import React, {
  useState,
  useEffect
} from 'react';
import { Eye } from 'lucide-react';
import { Prompt, Category } from '../types';
import { getCategoryName } from '../utils/category';

interface PromptCardProps {
  prompt: Prompt;
  hideSensitive?: boolean;
  onClick?: (prompt: Prompt) => void;
  categories: Category[];
}

const PromptCard: React.FC<PromptCardProps> = ({
  prompt,
  hideSensitive = false,
  onClick,
  categories
}) => {
  const [revealed, setRevealed] = useState(false);
  const [imageLoaded, setImageLoaded] =
  useState(false);
  const [imageError, setImageError] =
  useState(false);
  const isBlurred = 
  prompt.isSensitive && 
  hideSensitive && 
  !revealed;

  const handleClick = () => {
    if (isBlurred) {
      setRevealed(true);
      return;
    }

    if (onClick) {
      onClick(prompt);
    }

  };

useEffect(() => {

  if (hideSensitive) {
    setRevealed(false);
  }

}, [hideSensitive]);

  return (


    <div
      className="relative bg-dark-800 rounded-xl border border-dark-700 overflow-hidden shadow-sm md:hover:shadow-lg transition-all duration-300 cursor-pointer"
      onClick={handleClick}
    >
      
      <div className="w-full aspect-[4/4.8] overflow-hidden bg-dark-900 relative">
      
{!imageLoaded && !imageError && (

  <div
    className="
      absolute inset-0
      bg-dark-700
      animate-pulse
    "
  />

)}

        {prompt.imageUrl && !imageError ? (
          <img
            src={prompt.imageUrl}
            loading="lazy"
            alt="Prompt"
            onError={() => {
  setImageError(true);
}}
            onLoad={() => setImageLoaded(true)}
            
            className={`

w-full h-full object-cover

transition-opacity duration-500

${imageLoaded
  ? 'opacity-100'
  : 'opacity-0'}

${isBlurred
  ? 'brightness-40 scale-110 [filter:blur(12px)]'
  : ''}

`}
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center bg-dark-900 text-dark-500">Imagem não disponível</div>
        )}

        {isBlurred && (
          <div className="absolute inset-0 flex flex-col items-center justify-center gap-2 bg-black/55 text-white px-4">
            <Eye size={22} />
            <span className="text-sm font-medium text-center">Clique para visualizar</span>
          </div>
        )}
      </div>

      <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/90 to-transparent p-3 sm:p-4">
        <div className="flex items-center justify-between gap-3">
          <span className="px-2 py-1 bg-purple-900/80 text-purple-200 text-xs rounded-full">
            {
  getCategoryName(
    prompt.categoryId,
    categories,
    prompt.categoryName
  )
}
          </span>
          {prompt.identifier && (
            <span className="text-dark-200 text-[11px] sm:text-xs truncate max-w-[120px]">
              {prompt.identifier}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default PromptCard;
